import { useState, Fragment } from 'react';
import './Landing.css';
import InfoPage, { INFO_LINKS } from './InfoPage';
import { useI18n } from './i18n';
import Icon from './Icon';

const FEATURES = [
  { icon: '📇', key: 'f1' },
  { icon: '🔔', key: 'f2' },
  { icon: '⚡', key: 'f3' },
  { icon: '🤝', key: 'f4' },
];

function Landing({ onGetStarted }) {
  const { t } = useI18n();
  // Deep-link support: /?page=terms opens that info view directly. This is what lets the
  // static marketing pages (client/public/*.html) link back to About/Help/Terms/Privacy.
  const [infoView, setInfoView] = useState(() => {
    const p = new URLSearchParams(window.location.search).get('page');
    return INFO_LINKS.some(l => l.key === p) ? p : null;
  });

  if (infoView) {
    return <InfoPage page={infoView} onBack={() => setInfoView(null)}
      onNavigate={setInfoView} onGetStarted={onGetStarted} />;
  }

  return (
    <div className="landing">
      <header className="landing-nav">
        <div className="landing-brand"><span className="landing-logo"><Icon name="brand" size={22} /></span> iBetterAgent</div>
        <div className="landing-nav-actions">
          <button className="landing-signin" onClick={onGetStarted}>{t('landing.signin')}</button>
        </div>
      </header>

      <section className="landing-hero">
        <span className="landing-eyebrow">{t('landing.eyebrow')}</span>
        <h1 className="landing-title">{t('landing.title')}</h1>
        <p className="landing-sub">{t('landing.sub')}</p>
        <div className="landing-cta-row">
          <button className="landing-cta" onClick={onGetStarted}>{t('landing.getStarted')}</button>
          <span className="landing-cta-note">{t('landing.ctaNote')}</span>
        </div>
      </section>

      <section className="landing-features">
        {FEATURES.map(f => (
          <div className="landing-feature" key={f.key}>
            <span className="landing-feature-icon">{f.icon}</span>
            <h3>{t(`landing.${f.key}.title`)}</h3>
            <p>{t(`landing.${f.key}.text`)}</p>
          </div>
        ))}
      </section>

      <section className="landing-connect">
        <h2>{t('landing.connect.title')}</h2>
        <p>{t('landing.connect.text')}</p>
        <button className="landing-cta" onClick={onGetStarted}>{t('landing.connect.cta')}</button>
      </section>

      <footer className="landing-footer">
        <nav className="landing-footer-links">
          {INFO_LINKS.map(l => (
            <Fragment key={l.key}>
              <button className="landing-footer-link" onClick={() => setInfoView(l.key)}>{t(`info.${l.key}`)}</button>
              {/* Static marketing flyer (client/public) — a real page, not an InfoPage view. */}
              {l.key === 'about' && <a className="landing-footer-link" href="/why-ibetteragent.html">{t('info.why')}</a>}
            </Fragment>
          ))}
        </nav>
        <div className="landing-footer-copy">{t('landing.footer')}</div>
      </footer>
    </div>
  );
}

export default Landing;
